const POSITION_CONTAINER = "ol-position-container"; 

const initPositionContainer = (map) => {
	const target = map.getOverlayContainerStopEvent();
	
	const element = document.createElement("div");
	element.className = POSITION_CONTAINER;
	
	target.appendChild( element );
	return element;	
}

const link_control = (viewport, source, target) => {
	const sourceElement = source.element;
	const targetElements = target.element;

	const updateEntries = () => {
		const mapRect = viewport.getBoundingClientRect();
		let rect = sourceElement.getBoundingClientRect();
		
		const element = target;	
		element.style.left = rect.width + ((rect.left - mapRect.left)) + 8 + "px";
	}

	const resizeObserver = new ResizeObserver(entries => updateEntries());
	resizeObserver.observe(sourceElement);
	
	updateEntries();
};

export {
	link_control, initPositionContainer
}